<template>
    <header class="widget__header">
        <h3 class="widget__heading">
            <slot name="heading">
                {{ heading }}
            </slot>
        </h3>

        <common-info-tip v-if="hint || $slots.hint">
            <slot name="hint">
                {{ hint }}
            </slot>
        </common-info-tip>
    </header>
</template>

<script>
    export default {
        props: {
            heading: { type: String, default: undefined },
            hint: { type: String, default: undefined },
        },
    }
</script>
